import { apiUrl } from '.';

// apiConfig ra-log-monitor theo shape + convention KEY của repo đích.
// Quy tắc:
//   - permissionCode = ĐƯỜNG DẪN API TRẦN (đúng chuỗi backend trả trong permission.action),
//     đặt ở endpoint có mặt trong mảng permissions của sitePathConfig
//   - ⚠️ id nối vào ĐƯỜNG DẪN (`${path}/${id}`) cho getById/delete -> khai '/:id' + pathParams
//   - Đăng nhập 2 bước: login -> nhận `requestToken` -> verify_otp (KHÔNG có TOTP/QR như mreport)

const baseHeader = {
    'Content-Type': 'application/json',
    Accept: '*/*',
};

const multipartFormHeader = {
    'Content-Type': 'multipart/form-data',
};

const apiConfig = {
    file: {
        upload: {
            path: `${apiUrl}/v1/file/upload`,
            method: 'POST',
            headers: multipartFormHeader,
        },
    },
    account: {
        login: {
            baseURL: `${apiUrl}/v1/account/login`,
            method: 'POST',
            headers: baseHeader,
        },
        // Bước 2 của đăng nhập: gửi { otp, requestToken }
        loginOtp: {
            baseURL: `${apiUrl}/v1/account/verify_otp`,
            method: 'POST',
            headers: baseHeader,
        },
        logout: {
            baseURL: `${apiUrl}/v1/account/logout`,
            method: 'GET',
            headers: baseHeader,
        },
        getProfile: {
            baseURL: `${apiUrl}/v1/account/profile`,
            method: 'GET',
            headers: baseHeader,
        },
        // Cùng endpoint; saga đăng nhập của nguồn gọi tên này
        getAdminProfile: {
            baseURL: `${apiUrl}/v1/account/profile`,
            method: 'GET',
            headers: baseHeader,
        },
        updateProfile: {
            baseURL: `${apiUrl}/v1/account/update_profile`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    user: {
        getList: {
            baseURL: `${apiUrl}/v1/account/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: '/v1/account/list',
        },
        getById: {
            baseURL: `${apiUrl}/v1/account/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: '/v1/account/get',
        },
        createAdmin: {
            baseURL: `${apiUrl}/v1/account/create_admin`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: '/v1/account/create_admin',
        },
        updateAdmin: {
            baseURL: `${apiUrl}/v1/account/update_admin`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: '/v1/account/update_admin',
        },
        delete: {
            baseURL: `${apiUrl}/v1/account/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: '/v1/account/delete',
        },
    },
    groupPermission: {
        // Dropdown nhóm quyền trong form Admin
        getListCombobox: {
            baseURL: `${apiUrl}/v1/group/list_combobox`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    logs: {
        // "Quản lí đơn hàng" — /logs
        getList: {
            baseURL: `${apiUrl}/v1/logs/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: '/v1/logs/list',
        },
        getById: {
            baseURL: `${apiUrl}/v1/logs/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: '/v1/logs/get',
        },
        create: {
            baseURL: `${apiUrl}/v1/logs/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: '/v1/logs/create',
        },
        delete: {
            baseURL: `${apiUrl}/v1/logs/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: '/v1/logs/delete',
        },
    },
};

export default apiConfig;
